import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LanguageService } from '@hazmatsuite-next/ui';
import { Store } from '@ngrx/store';
import { Observable, map } from 'rxjs';
import { InnerPackagingModel } from '../../../models/inner-packaging.model';
import { Packages } from '../../../models/packages.interface';

@Component({
  selector: 'lib-inner-packaging-item',
  templateUrl: './inner-packaging-item.component.html',
  styleUrls: ['./inner-packaging-item.component.scss'],
})
export class InnerPackagingItemComponent {
  @Input() item?: InnerPackagingModel;
  @Input() hideIcons = false;
  @Input() isLast = false;
  @Input() showPrintLabel = false;

  @Output() editPackage = new EventEmitter<void>();
  @Output() duplicateInnerPackage = new EventEmitter<InnerPackagingModel>();
  @Output() removeInnerPackage = new EventEmitter<InnerPackagingModel>();

  public packingListResource$: Observable<any> = this.languageService.translations$.pipe(
    map(translations => translations['PackingListResource']));

  constructor(
    private languageService: LanguageService,
    private store: Store<{ packageList: { packages: Packages } }>) { }

  edit(): void {
    this.editPackage.next();
  }

  copyPackage(): void {
    this.duplicateInnerPackage.emit(this.item);
  }

  removePackage(): void {
    this.removeInnerPackage.emit(this.item);
  }

  printLabel(): void {
    alert('FIXME: Not implemented, yet');
    const url = `/${this.languageService.getLanguage()}/easydgd/smartlabel?packageId=${this.item?.Id}`;
    window.open(url, '_blank')?.focus();
  }
}
